// extracted by mini-css-extract-plugin
export default {"contentBox":"Company_contentBox__xJUCG","relative":"Company_relative__2pnLD"};